import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';

import * as Styled from './Header.style';

function Header({ title, image }) {
  const { formatMessage } = useIntl();

  return (
    <>
      <Styled.Heading>
        <FormattedMessage id={title} />
      </Styled.Heading>
      <Styled.ImageContainer>
        <Styled.HeaderImage
          alt={image.alt ? formatMessage({ id: image.alt }) : image.alt}
          src={image.src}
          objectposition={image.objectPosition || 'top'}
        />
      </Styled.ImageContainer>
    </>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    objectPosition: PropTypes.string,
  }).isRequired,
};

export default Header;
